"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.6.0'] && _();
}
catch (e) { }
